export interface CaseStudy {
  id: string;
  brand: string;
  subtitle: string;
  industry: string;
  service: string;
  heroImage: string;
  brandColor: string;
  brandBg: string;
  challengeIntro: string;
  challengePoints: string[];
  results: string[];
}

export const caseStudies: CaseStudy[] = [
  {
    id: 'mengniu',
    brand: '蒙牛',
    subtitle: '促动销、管分销、提费效——营销费用从"大水漫灌"升级为"精准滴灌"',
    industry: '食品饮料',
    service: 'bC营销数字化全链路运营',
    heroImage:
      '/images/case-mengniu.jpg',
    brandColor: 'bg-blue-600',
    brandBg: 'bg-blue-50',
    challengeIntro:
      '乳品行业传统营销模式粗放，渠道层级冗余，营销费用层层截留，终端动销动力不足，库存周转效率低，临期产品损耗居高不下——这是蒙牛在数字化转型前面临的典型行业困境。',
    challengePoints: [
      '营销费用"大水漫灌"，投放粗放、效果难以评估',
      '渠道层级冗长，费用层层截留，终端实际获利微薄',
      '终端动销数据缺失，库存周转效率低下',
      '临期产品积压损耗严重，大日期处理被动低效',
      '新品推广缺乏数字化赋能，动销爬坡周期长',
    ],
    results: [
      '费用截留骤降：营销费用实现"精准滴灌"式投放，部分区域营销费比大幅降低，渠道截留问题从根源得到解决',
      '全年费用大幅度降低：通过精细化场景应用与关键角色精准激励，分销效率、动销效率、费用使用效率全面提升',
      '数据驱动决策：品牌真正实现"看清渠道、摸透终端、连接消费者"，从粗放经营全面升级为数据驱动的精细化运营模式',
      '规模化复制就绪：西北区域试点模式成熟、成效显著，同等投入下终端转化效果翻倍，已全面具备全国规模化复制落地条件',
    ],
  },
  {
    id: 'kangshifu',
    brand: '康师傅',
    subtitle: '五码合一，从生产端到消费者——链路数据全闭环',
    industry: '食品饮料',
    service: '五码合一全链路数字化体系',
    heroImage:
      '/images/case-kangshifu.jpg',
    brandColor: 'bg-orange-500',
    brandBg: 'bg-orange-50',
    challengeIntro:
      '作为饮料行业的全国性头部品牌，康师傅面临渠道链路长、数据断层多、费用投放难以追踪、库存透明度不足等系统性挑战。品牌迫切需要一套能够贯穿生产端到消费者端的全链路数字化解决方案，实现渠道的真正透明化管控。',
    challengePoints: [
      '渠道链路长，从生产到消费数据断层多，难以追溯',
      '门店不透明：品牌方对终端门店的实际经营数据、动销情况、铺货状态完全不可见，无法掌握真实终端画像',
      '渠道库存不透明：各层级渠道库存数据无法实时掌握，库存积压、断货、窜货等风险无法及时预警',
      '营销费用流向不清晰，浪费与截留并存',
    ],
    results: [
      '链路数据全闭环：从生产端到消费者，数据断层问题彻底解决，全链路可追溯',
      '门店动销可追踪：终端扫码数据实时回传，动销情况分钟级可见，异常自动预警',
      '费用投放有归处：费用与动销强关联，投放效果清晰可量化，ROI持续提升',
      '渠道库存看得清：库存数据透明化，呆滞库存提前预警，周转效率显著改善',
    ],
  },
  {
    id: 'wanglaoji',
    brand: '王老吉',
    subtitle: '百亿品牌从零建链路——费用不再层层截留',
    industry: '食品饮料',
    service: '物码营销数字化链路 + SFA一体化',
    heroImage:
      '/images/case-wanglaoji.jpg',
    brandColor: 'bg-red-600',
    brandBg: 'bg-red-50',
    challengeIntro:
      '年营业额超百亿的凉茶行业巨头王老吉，长期面临渠道链路冗长、层级分流严重的行业顽疾：营销费用经由经销商→二批商→终端门店层层流转，截留严重，终端获利薄弱，动销动力严重不足；品牌方对渠道费用流向缺乏透明度，精准管控几乎无从实现。',
    challengePoints: [
      '渠道链路冗长，经销商→二批商→终端层层截留',
      '终端获利薄弱，动销动力严重不足',
      '品牌方对费用流向零透明度，精准管控无从实现',
      '百亿级体量下，从零搭建数字化链路难度极高',
      '消费者与终端缺乏有效互动机制，复购率提升困难',
    ],
    results: [
      '从零到有，快速建链：优先选取广东数百个核心终端门店开展试点，快速验证模式可行性，为全国推广奠定基础',
      '费用截留顽疾破解：全链路费用传递通道全面疏通，营销资源精准直达百万终端，截留问题从机制上得到根本性解决',
      '终端获得感大幅提升：终端门店扫码即获真实奖励，动销积极性显著提升，"终端更愿意卖"从口号变为现实',
      '消费者互动激活：消费者扫码领红包，购买体验升级，复购率与品牌粘性同步提升，"消费者更愿意买"有数据支撑',
      '可复用实战范本：为百亿级快消品牌从零搭建数字化体系、实现渠道透明化管控提供了可落地、可复用、可复制的完整解决方案',
    ],
  },
];